import script from "./Instructors.vue?vue&type=script&setup=true&lang=js"
export * from "./Instructors.vue?vue&type=script&setup=true&lang=js"

import "./Instructors.vue?vue&type=style&index=0&id=746e00ae&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746e00ae"]])

export default __exports__